import _ from 'lodash';

import registerConstants from '../constants/register-constants';
import Helpers from '../../../../common/helpers';
import RegisterHelpers from '../helpers/register-helpers';

export const validate = (values, props) => {
  const step = registerConstants.form_steps[props.params.step];
  const userRegisterObject = RegisterHelpers.getUserRegisterObject();

  if (userRegisterObject && userRegisterObject.user_type && step) {
    const fields = _.filter(step.fields, field => {
      return field.visible === userRegisterObject.user_type || field.visible === props.location.query.user_type || field.visible === registerConstants.visible_all;
    });

    return Helpers.validateForm(values, fields);
  } else return {};
};



// WEBPACK FOOTER //
// ./src/app/main/register/validators/register-validators.js